import script from "./ContentSide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentSide.vue?vue&type=script&lang=ts&setup=true"

import "./ContentSide.vue?vue&type=style&index=0&id=39c0028e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c0028e"]])

export default __exports__